/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import Avatar from '@mui/material/Avatar';
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import NavLinkAdapter from "../../../../@BASE/core/NavLinkAdapter";
import { displayRole } from "../../../shared-components/DisplayRole";

function UserListItem(props) {
  const { user } = props;
  return (
    <>
      <ListItem
        className="px-32 py-16"
        sx={{ bgcolor: "background.paper" }}
        button
        component={NavLinkAdapter}
        to={`/users/${user.id}/edit`}
      >
        <ListItemAvatar>
          <Avatar 
            alt={user.first_name}
            sx={{
              backgroundColor: user.settings.color,
              color: user.settings.color != '#80F2E7' && user.settings.color != '#FFF54F' ? 'common.white' : 'common.black',
            }}
            className="text-16 font-bold"
          >
            {user.first_name[0]}{user.last_name[0]}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          classes={{ root: "m-0", primary: "font-medium leading-5 truncate" }}
          primary={user.first_name + " " + user.last_name}
          secondary={
            <>
              <Typography
                className="inline"
                component="span"
                variant="body2"
                color="text.secondary"
              >
                {displayRole(user.role)}
              </Typography>
            </>
          }
        />
      </ListItem>
      <Divider />
    </>
  );
}

export default UserListItem;
